(()=>{function boot(){const root=document.querySelector('[data-journal309]');if(!root||root.dataset.ready309)return;root.dataset.ready309='true';
const valid = new Set(root.dataset.pillars.split("|"));
function normalizePillar(value='') {
  const key=String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim().replace(/\s+/g,'-');
  return valid.has(key)?key:'';
}
function selectArticles(articles,pillar='') {
  const key=normalizePillar(pillar);
  return articles.filter(a=>!key||normalizePillar(a.pillar)===key);
}
function filterUrl(input,pillar='') {
  const url=new URL(input,location.origin);
  const key=normalizePillar(pillar);
  if(key)url.searchParams.set('pilon',key);else url.searchParams.delete('pilon');
  return url.pathname+url.search+'#lecturi';
}
function relatedArticles(articles,article,limit=3) {
  const rest=articles.filter(a=>a.handle!==article.handle);
  return [...rest.filter(a=>a.pillar===article.pillar),...rest.filter(a=>a.pillar!==article.pillar)].slice(0,limit);
}


const grid=root.querySelector('#j-articles');
const filters=[...root.querySelectorAll('[data-filter]')];
function applyFilter(value,{history=false}={}){
 const key=normalizePillar(value);
 let total=0;
 for(const article of grid.querySelectorAll('[data-guide]')){
  article.hidden=Boolean(key&&article.dataset.pillar!==key);
  if(!article.hidden)total++;
 }
 for(const button of filters)button.setAttribute('aria-pressed',String(button.dataset.filter===key));
 root.querySelector('[data-count]').textContent=total+' '+(total===1?root.dataset.countOne:root.dataset.countMany);
 for(const link of root.querySelectorAll('[data-article-link]')){
  const url=new URL(link.href);
  if(key)url.searchParams.set('pilon',key);else url.searchParams.delete('pilon');
  link.href=url.pathname+url.search;
 }
 if(history&&normalizePillar(new URL(location.href).searchParams.get('pilon'))!==key){
  window.history.pushState({pillar:key},'',filterUrl(location.href,key));
 }
}
if(grid){
 root.querySelector('[data-filters]').hidden=false;
 root.querySelector('.all-filter').hidden=false;
 applyFilter(new URL(location.href).searchParams.get('pilon'));
 for(const button of filters)button.addEventListener('click',()=>applyFilter(button.dataset.filter,{history:true}));
 window.addEventListener('popstate',()=>applyFilter(new URL(location.href).searchParams.get('pilon')));
}
const selected=normalizePillar(new URL(location.href).searchParams.get('pilon'));
for(const link of root.querySelectorAll('[data-back-journal]'))link.href=root.dataset.blogUrl+(selected?'?pilon='+selected:'')+'#lecturi';
for(const figure of root.querySelectorAll('.art')){
 const img=figure.querySelector('img'),message=figure.querySelector('.art-error');
 
 const fail=()=>{message.hidden=false;figure.dataset.state='error';};
 img.addEventListener('error',fail);
 img.addEventListener('load',()=>{message.hidden=true;figure.dataset.state='ready';});
 if(img.complete&&!img.naturalWidth)fail();
}
const film=root.querySelector('[data-film]');
if(film){
 const video=film.querySelector('video');let pausedByUser=false;
 const state=()=>{film.setAttribute('aria-pressed',String(!video.paused));film.setAttribute('aria-label',video.paused?film.dataset.play:film.dataset.pause);};
 video.muted=true;video.defaultMuted=true;
 video.addEventListener('play',state);video.addEventListener('pause',state);
 film.addEventListener('click',()=>{if(video.paused){pausedByUser=false;video.play().catch(state);}else{pausedByUser=true;video.pause();}});document.addEventListener('visibilitychange',()=>{if(!document.hidden&&!pausedByUser)video.play().catch(state);});
 video.play().catch(state);
}
const toc=root.querySelector('.toc details');
if(toc){
 const narrow=matchMedia('(max-width:800px)');
 toc.open=!narrow.matches;
 narrow.addEventListener('change',e=>{toc.open=!e.matches;});
 for(const link of toc.querySelectorAll('a'))link.addEventListener('click',event=>{
  const target=document.getElementById(decodeURIComponent(link.hash.slice(1)));
  if(target){if(!event.defaultPrevented&&event.button===0&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&!event.altKey&&typeof window.tosVerticalScroll==='function'){event.preventDefault();const url=new URL(location.href);url.hash=target.id;window.history.pushState({},'',url);window.tosVerticalScroll(target,{block:'start',behavior:'auto'});}target.tabIndex=-1;requestAnimationFrame(()=>target.focus({preventScroll:true}));}
 });
}

}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();document.addEventListener('shopify:section:load',boot);})();
